import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import BlogList from './components/BlogList';
import BlogPost from './components/BlogPost';
import ScrollToTop from './components/ScrollToTop';
import SeoPinger from './components/SeoPinger';
import WhatsAppButton from './components/WhatsAppButton';
import Shop from './components/Shop';
import CheckoutPage from './components/CheckoutPage';
import ProductPage from './components/ProductPage';
import FloatingVideo from './components/FloatingVideo';
import SeoPage from './components/SeoPage';
import SalasPage from './components/SalasPage';
import PricingPage from './components/PricingPage';
import WorkshopLanding from './components/WorkshopLanding';

function App() {
  return (
    <div className="min-h-screen bg-black font-sans text-white selection:bg-yellow-500 selection:text-black">
      <SeoPinger />
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/salas" element={<SalasPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/p/:slug" element={<ProductPage />} />
          {/* ✅ Repurposed Workshop Route */}
          <Route path="/p/workshop-ingles-negocios-2026" element={<WorkshopLanding />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/topic/:slug" element={<SeoPage />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
      <FloatingVideo />
    </div>
  );
}

export default App;